import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./sw-popup.mjs";
import { render } from "lit-html";
import { LANGUAGE, HB_VAULT, HB_ORG } from "../../global.ts";
import Strings from "../../../models/Strings.json";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

const strings: any = Strings;

export class SwPopup extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private modal: ModalInterface;
    private opener: Window | null = null;

    private popup: HTMLElement;
    private iframe: HTMLIFrameElement;
    private btn: HTMLButtonElement;

    constructor() {
        super();
        render(template(null), this);

        this.popup = this.querySelector("#sw-popup")!;
        this.iframe = this.querySelector("#sw-popup-iframe")!;
        this.btn = this.querySelector("#sw-popup-btn")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                this.popup.style.zIndex = "70";
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "sw-popup",
            override: true
        };

        this.modal = new Modal(this.popup, modalOptions, instanceOptions);
    }

    connectedCallback() {
        window.addEventListener("message", (event: MessageEvent) => {
            if (event.origin === HB_VAULT)
                this.handleMessageFromPopup(event.data);
        });
    }

    public show(src: string) {
        this.iframe.src = src;
        this.modal.show();
    }

    private hide() {
        this.modal.hide();
    }

    // browser only allows popups to be opened in response to a user action unless user specifically allows
    // TODO: when account is updated => postMessage to opener => re-render // display name
    openVault(page: string, showIframe: boolean = false) {
        const url =
            HB_VAULT +
            `/?lang=${strings.language[LANGUAGE]}&origin=${
                this.heartbank.isRunningAsPWA() ? "pwa" : "web"
            }#/${page}`;
        this.opener = window.open(
            url,
            "HeartBank® Vault",
            "width=500,height=500"
        );
        if (!this.opener) {
            if (showIframe) this.show(url);
            else alert(strings.feedback7[LANGUAGE]); // iframe does not store login state
        }
    }

    openHB(page: string, showIframe: boolean = false) {
        const url =
            HB_ORG +
            `/?lang=${strings.language[LANGUAGE]}&origin=${
                this.heartbank.isRunningAsPWA() ? "pwa" : "web"
            }#/${page}`;
        this.opener = window.open(
            url,
            "HeartBank® Vault",
            "width=500,height=500"
        );
        if (!this.opener) {
            if (showIframe) this.show(url);
            else alert(strings.feedback7[LANGUAGE]); // iframe does not store login state
        }
    }

    private async handleMessageFromPopup(data: {
        action: string;
        [key: string]: any;
    }) {
        switch (data.action) {
            case "success":
                this.opener?.close();
                this.hide();
                break;
            case "logout":
                this.opener?.close();
                this.hide();
                break;
            case "error":
                this.opener?.close();
                this.hide();
                //window.location.hash = "#";
                alert(data.text);
                break;
            default:
            //console.log("Unknown action: ", data);
        }
    }

    private sendMessageToPopup(data: {
        action: string;
        [key: string]: any;
    }): void {
        this.opener?.postMessage(data, HB_VAULT);
    }
}
